import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
	ImageField,
	ImageInput,
	required,
	SelectInput,
	TextInput,
	useRecordContext,
} from "react-admin";
import { Box, Paper, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";

const UploadOrUrlImageInput = (props) => {
	const record = useRecordContext() || {};
	const { source, label, required: r, ...rest } = props;
	const [imgPrev, setImgPrev] = useState(record[source]);
	const mode = useWatch({ name: source + "__mode__", defaultValue: "url" });

	const createValidators = useCallback(
		(m, defaultValidators = []) => {
			let validators = defaultValidators;
			if (r && mode === m) {
				validators.push(required());
			}
			return validators;
		},
		[r, mode]
	);

	const urlValidators = useMemo(() => createValidators("url", [setImgPrev]), [createValidators]);
	const uploadValidators = useMemo(() => createValidators("upload", []), [createValidators]);

	return (
		<Paper elevation={1}>
			<Box p="0.5em 1em 0 1em">
				<Typography>{label}</Typography>
				<SelectInput
					source={source + "__mode__"}
					choices={[
						{ id: "url", name: "URL" },
						{ id: "upload", name: "Upload" },
					]}
					label={label + " type"}
					defaultValue={"url"}
					required={r}
					isRequired={r}
				/>
				<Box display={mode === "url" ? "block" : "none"}>
					<TextInput
						source={source + "__url__"}
						label={label + " (URL)"}
						{...rest}
						defaultValue={record[source]}
						required={r && mode === "url" ? true : undefined}
						validate={urlValidators}
						onBlur={(e) => {
							setImgPrev(e?.target?.value);
						}}
					/>
					<img src={imgPrev} alt={label + " preview"} style={{ maxWidth: "500px" }} />
				</Box>
				<Box display={mode === "upload" ? "block" : "none"}>
					<ImageInput
						source={source + "__img__"}
						label={label + " (upload)"}
						{...rest}
						required={r && mode === "upload" ? true : undefined}
						validate={uploadValidators}
					>
						<ImageField source="src" sx={{ maxWidth: "500px" }} />
					</ImageInput>
				</Box>
			</Box>
		</Paper>
	);
};

export { UploadOrUrlImageInput };
